



























import Vue from 'vue'
import Component from 'vue-class-component'
import User from '@/provider/user'
const lessonQuestions = require('@/assets/lesson-comments.json')

@Component
export default class Lesson extends Vue {
  loading: boolean = true
  userProvider!: User
  userId: string = ''
  lessonComments: Array<any> = [];
  lessonInputComments = lessonQuestions;
  lessonCommentsHeaders: Array<any> = [
    {
      text: 'レッスン',
      align: 'center',
      sortable: false,
      width: '8%'
    },
    {
      text: '質問者',
      align: 'left',
      sortable: false,
      width: '7%'
    },
    {
      text: '質問',
      align: 'left',
      sortable: false,
      width: '35%'
    },
    {
      text: 'ユーザー回答',
      align: 'left',
      sortable: false
    }
  ]

  beforeMount () {
    this.userId = this.$route.params.userId
    this.userProvider = new User(this.userId)
    this.loadUserData()
    console.log('comments', this.lessonInputComments)
  }

  async loadUserData () {
    this.loading = true
    const lessonObj: any = (await this.userProvider.getLesson()).lessons
    const lessonComments: Array<any> = []
    for (let i = 0; i < lessonObj.length; i++) {
      const lesson = lessonObj[i]
      for (const part of lesson.lessonParts) {
        const { partIndex, lessonInputs } = part
        for (const key of Object.keys(lessonInputs)) {
          const lessonInputComment = this.lessonInputComments[key]
          const name = lessonInputComment ? lessonInputComment.name : ''
          const text = lessonInputComment ? lessonInputComment.text : ''
          const order = lessonInputComment ? lessonInputComment.order : 0
          const lessonInput = lessonInputs[key]
          const userInput = lessonInput !== undefined ? lessonInput : ''
          lessonComments.push({
            key: key,
            tableKey: `${lesson.lessonId.toUpperCase()} Part ${partIndex}`,
            name: name,
            text: text,
            value: userInput,
            lessonIndex: i,
            partIndex: partIndex,
            order: order
          })
        }
      }
    }
    lessonComments.sort((a, b) => {
      if (a.lessonIndex < b.lessonIndex) return -1
      if (a.lessonIndex > b.lessonIndex) return 1
      if (a.partIndex < b.partIndex) return -1
      if (a.partIndex > b.partIndex) return 1
      if (a.order < b.order) return -1
      if (a.order > b.order) return 1
      return 0
    })
    console.log('lessonComments:', lessonComments)
    this.lessonComments = lessonComments
    this.loading = false
  }
}
